export default __webpack_public_path__ + "static/media/3AB_360_4_alt.cd35edbd.jpg";